import { render, staticRenderFns } from "./router.vue?vue&type=template&id=7aaaa292"
import script from "./router.vue?vue&type=script&lang=js"
export * from "./router.vue?vue&type=script&lang=js"
import style0 from "./router.vue?vue&type=style&index=0&id=7aaaa292&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports